import { render, staticRenderFns } from "./LocationsBookType.vue?vue&type=template&id=7906524e&scoped=true&"
import script from "./LocationsBookType.vue?vue&type=script&lang=js&"
export * from "./LocationsBookType.vue?vue&type=script&lang=js&"
import style0 from "./LocationsBookType.vue?vue&type=style&index=0&id=7906524e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7906524e",
  null
  
)

export default component.exports